import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

import "@fortawesome/fontawesome-free/css/all.css";

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(Vuetify);

let useDarkMode = false;

if (
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: dark)").matches
) {
  // Dark Mode ist aktiviert
  useDarkMode = true;
  console.log("Dark Mode ist aktiviert");
} else {
  // Light Mode ist aktiviert
  useDarkMode = false;
  console.log("Light Mode ist aktiviert");
}

export default new Vuetify({
  icons: {
    iconfont: "fa",
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: useDarkMode,
    themes: {
      light: {
        primary: "#00aaff",
        secondary: "white",
        accent: "#FF5500",
      },
      dark: {
        primary: "#00aaff",
        secondary: "white",
        accent: "#FF5500",
      },
    },
  },
});
